<!--  -->
<template>
  <div class=''>

    <div class="Item-add">
      <a @click="dialogVisible = true;">- 新增图片 -</a>
    </div>
    <div class="priture-group">
      <div class="priture-item"
           v-for="(item,index) in pics">
        <img :src="item.filepath">
        <p>
          {{item.filepath}}
        </p>
      </div>
    </div>

    <el-dialog title="提示"
               :visible.sync="dialogVisible"
               width="30%">

      <el-upload class="upload-demo"
                 drag
                 action="http://api.newlong.com.cn/admin/addPicture"
                 :headers="headers"
                 :before-upload="beforeUpload"
                 :on-success="success"
                 :on-error="error"
                 multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip"
             slot="tip">只能上传jpg/png文件，且不超过500kb</div>
      </el-upload>

    </el-dialog>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

var Editor = require("@tinymce/tinymce-vue").default;
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    editor: Editor // <- Important part
  },
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
      pics: [],
      headers:{t:''}
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    beforeUpload(){
      this.headers.t = localStorage.getItem("token");
    },
    success(response, file, fileList) {
        console.log(response)
        this.pics = response.data
    },
    error(err, file, fileList) {
        console.error(err)

    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

    var that = this;
    this.$request.get({
      url: "/api/pageData/admin/picture",
      callback: {
        success: function(data) {
          that.pics = data.data;
        },
        err: function(err) {
          console.log(err);
        }
      }
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.priture-group {
  display: flex;
  flex-wrap: wrap;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0 15px;
}

.priture-item {
  width: 32%;
  border: 1px solid #e7e7e7;
  margin: 10px 0.1%;
  background-color: #ffffff;
  padding: 5px;
  -webkit-box-shadow: 0 0 8px #ddd;
  box-shadow: 0 0 8px #ddd;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.priture-item p {
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  margin: 10px;
}

.priture-item img {
  text-align: center;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
</style>